import * as React from "react";
import { TextInput, Create, required, SimpleFormIterator, ArrayInput } from "react-admin";
import { ProductCategoryCreateComponent } from "./";
import { FileInput } from "src/components/file-input";
import { Grid } from "@mui/material";
import { SimpleForm } from "src/enterprise/ra-rbac";

export const ProductCategoryCreate = () => {
  return (
    <Create component={ProductCategoryCreateComponent}>
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} lg={8}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12} lg={8}>
            <ArrayInput source="dynamic" helperText="Set dynamic params to use for listing instead of category id.">
              <SimpleFormIterator inline>
                <TextInput source="name" />
                <TextInput source="value" />
              </SimpleFormIterator>
            </ArrayInput>        
          </Grid>
          <Grid item sm={12} lg={8}>
            <TextInput
              source="description"
              multiline
              resettable
              sx={{
                "#description": { minHeight: "90px", height: "100%" },
                minWidth: "35vw",
              }}
            />
          </Grid>
          <Grid item sm={12}>
            <FileInput
              source="image"
              fileTypes={["JPG", "PNG", "GIF", "SVG", "WEBP", "MP4"]}
              multiple={false}
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
